/* KHUN CLUB · búsqueda de fichas (series, ships, actrices, glosario y agenda) mientras escribes.
   La primera vez los resultados llegan pintados desde el servidor (sections/khun-busqueda.liquid).
   Shopify no busca dentro de los metaobjetos; las notas y páginas las trae la búsqueda nativa. */
(() => {
  const raiz = document.querySelector('[data-kc-busqueda]');
  if (!raiz) return;
  // El índice termina en null para que Liquid pueda poner coma después de cada ficha
  const indice = JSON.parse(raiz.querySelector('[data-kc-busqueda-indice]').textContent).filter(Boolean);
  const campo = document.querySelector('[data-kc-busqueda-q]');
  const destino = raiz.querySelector('[data-kc-busqueda-fichas]');
  const conteo = raiz.querySelector('[data-kc-busqueda-conteo]');
  const vacio = raiz.querySelector('[data-kc-busqueda-vacio]');
  const nativas = Number(raiz.querySelector('[data-kc-busqueda-nativa]')?.dataset.kcBusquedaNativa ?? 0);

  const normalizar = (t) => String(t ?? '').normalize('NFD').replace(/[̀-ͯ]/g, '').toLowerCase();
  for (const f of indice) f.qn = normalizar(`${f.n} ${f.q}`);

  const GRUPOS = [
    ['serie', 'Series', 'azure', 'Serie'],
    ['ship', 'Ships', 'rose', 'Ship'],
    ['actriz', 'Actrices', 'amber', 'Actriz'],
    ['termino', 'Glosario', 'mint', 'Término'],
    ['evento', 'Agenda', 'tomato', 'Evento'],
  ];

  const crear = (etiqueta, clase, texto) => {
    const el = document.createElement(etiqueta);
    if (clase) el.className = clase;
    if (texto !== undefined) el.textContent = texto;
    return el;
  };

  function pintar(q) {
    const terminos = normalizar(q).split(/\s+/).filter(Boolean);
    destino.replaceChildren();
    if (!terminos.length) {
      conteo.textContent = '';
      vacio.hidden = true;
      return;
    }
    // Primero las que empiezan con lo buscado, luego las que lo contienen
    const coinciden = indice
      .filter((f) => terminos.every((t) => f.qn.includes(t)))
      .sort((a, b) => Number(!normalizar(a.n).startsWith(terminos[0])) - Number(!normalizar(b.n).startsWith(terminos[0])));
    for (const [tipo, titulo, color, singular] of GRUPOS) {
      const lista = coinciden.filter((f) => f.t === tipo);
      if (!lista.length) continue;
      const grupo = crear('div', 'kc-busqueda__grupo');
      const h = crear('h2', 'kc-h3', `${titulo} `);
      h.append(crear('span', 'kc-mono', String(lista.length)));
      const ol = crear('ol', 'kc-busqueda__lista');
      for (const f of lista.slice(0, 12)) {
        const li = crear('li', 'kc-busqueda__item');
        li.append(crear('span', `kc-tag kc-tag--${color}`, singular));
        const a = crear('a', 'kc-busqueda__nombre', f.n);
        a.href = f.u;
        li.append(a);
        if (f.x) li.append(crear('span', 'kc-busqueda__extra', f.x));
        ol.append(li);
      }
      grupo.append(h, ol);
      destino.append(grupo);
    }
    const total = coinciden.length + nativas;
    conteo.textContent = `${total} ${total === 1 ? 'resultado' : 'resultados'}`;
    vacio.hidden = total > 0;
  }

  let espera;
  campo.addEventListener('input', () => {
    clearTimeout(espera);
    espera = setTimeout(() => pintar(campo.value), 150);
  });
  // Al cargar, las fichas ya vienen pintadas desde el servidor; aquí solo se repinta al escribir
})();
